(function () {
  function setRem() {
    const designWidth = 750;
    const base = 10; // 750px → 100px = 1rem（推荐）

    let width = document.documentElement.clientWidth;
    width = Math.min(width, designWidth);

    let rem = (width / designWidth) * base;
    document.documentElement.style.fontSize = rem + 'px';
  }

  setRem();
  window.addEventListener('resize', setRem);
})();